import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import * as actions from '../actions/TablaBuquesActions'
import { connect } from 'react-redux'
import EditIcon from '@material-ui/icons/Edit'
import { Dialog, Button } from '@material-ui/core'
import DialogoBuqueUpdate from '../components/DialogoBuqueUpdate'
import DialogView from '../../Dialogos/DialogView'

function EdicionBuques (props) {
  const { nombre, nombreBuque = null, edicionDesdeAnunciados = false } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async () => {
    handleClose()
    if (edicionDesdeAnunciados) {
      props.submitUpdateBuque(edicionDesdeAnunciados)
    } else {
      props.submitUpdateBuque()
    }
  }

  function onClick () {
    handleOpen()
  }

  return (
    <div>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xl'>
          <DialogView
            confirmCallback={handleSubmit}
            cancelCallback={handleClose}
            title='Editar Buque'
            content={
              <DialogoBuqueUpdate nombre={nombre} />
            }
          />

        </Dialog>

        { edicionDesdeAnunciados
          ? (nombreBuque
            ? <Tooltip title={'Editar buque'}>
              <Button onClick={handleOpen} style={{ outline: 'none', textAlign: 'left' }} >
                {nombreBuque}
              </Button>
            </Tooltip>
            : null
          )

          : <div>
            <Tooltip title={'Editar'}>
              <IconButton onClick={onClick}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          </div>
        }
      </div>
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(EdicionBuques)
